/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListUserCompaniesParams,
  UserCompaniesCollection,
  UserUnion
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Companies the current user can access through an active membership in a published group that has not opted out of the requested tools feature.
 * @summary List companies the current user can currently access
 */
export const listUserCompanies = (
    params?: MaybeRefOrGetter<ListUserCompaniesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<UserCompaniesCollection>(
      {url: `/users/companies`, method: 'GET',
        params, signal
    },
      );
    }




export const getListUserCompaniesQueryKey = (params?: MaybeRefOrGetter<ListUserCompaniesParams>,) => {
    return [
    'users','companies', ...(params ? [params] : [])
    ] as const;
    }


export const getListUserCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof listUserCompanies>>, TError = ErrorType<void>>(params?: MaybeRefOrGetter<ListUserCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListUserCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUserCompanies>>> = ({ signal }) => listUserCompanies(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>
}

export type ListUserCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof listUserCompanies>>>
export type ListUserCompaniesQueryError = ErrorType<void>


/**
 * @summary List companies the current user can currently access
 */

export function useListUserCompanies<TData = Awaited<ReturnType<typeof listUserCompanies>>, TError = ErrorType<void>>(
 params?: MaybeRefOrGetter<ListUserCompaniesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUserCompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUserCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Current User Details
 */
export const getMe = (

 signal?: AbortSignal
) => {


      return axiosClient<UserUnion>(
      {url: `/users/me`, method: 'GET', signal
    },
      );
    }




export const getGetMeQueryKey = () => {
    return [
    'users','me'
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<unknown>


/**
 * @summary Current User Details
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






